export default __webpack_public_path__ + "static/media/headshot.ac4c4430.jpg";